import { render, staticRenderFns } from "./cxFoodClaim.vue?vue&type=template&id=ca61069a&scoped=true&"
import script from "./cxFoodClaim.vue?vue&type=script&lang=js&"
export * from "./cxFoodClaim.vue?vue&type=script&lang=js&"
import style0 from "./cxFoodClaim.vue?vue&type=style&index=0&id=ca61069a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca61069a",
  null
  
)

export default component.exports